<template>
  <div style="margin-left:60px">
    <el-form :model="formData" :rules="ruleValidate" ref="cFrom" label-width="100px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="显示列名" prop="showName">
            <el-input v-model="formData.showName" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="字段名" prop="fieldName">
            <el-input v-model="formData.fieldName" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="类型" prop="fieldType">
            <el-select v-model="formData.fieldType" placeholder="请选择">
              <el-option label="字符" :value="'0'"></el-option>
              <el-option label="转码" :value="'1'"></el-option>
              <el-option label="日期" :value="'2'"></el-option>
              <el-option label="日期时间" :value="'3'"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4" style="min-height:1px">
          <el-form-item label-width="0" prop="exchange" v-if="formData.fieldType=='1'||formData.fieldType=='0'" class="tx-c">
            <el-button type="text" @click="setExchange">设置字段字典</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="2" class="tx-c" v-if="itemIndex>0">
          <el-button icon="el-icon-minus" @click="removeShowItem"></el-button>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      title="字段字典设置"
      :visible.sync="show"
      width="400px"
      :append-to-body="true"
      :before-close="handleClose"
    >
      <div>
        <el-row>
          <el-col :span="11">
            <div class="tx-c">原始值</div>
          </el-col>
          <el-col :span="11">
            <div class="tx-c">显示值</div>
          </el-col>
        </el-row>
        <ExchangeItemForm 
          v-for="(item, index) in formData.exchange" 
          :key="item.key" ref="dictionary" 
          @removeItem="removeItem(index)" 
          :defualtData="formData.exchange[index]"
          :exchangeIndex="index"
        />
        <div class="tx-c mt10"><el-button icon="el-icon-plus" @click="addExchange"></el-button></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="validateDictionaryForm">确 定</el-button>
        <el-button @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ExchangeItemForm from './exchangeItemForm'

export default {
  name: "showItemForm",
  components: {
    ExchangeItemForm,
  },
  props: ['itemIndex','myKey','itemData'],
  data() {
    return {
      show: false,
      baseUrl: process.env.BASE_URL,
      formData: {
        exchange: [],
        fieldName: '',
        fieldType: '',
        showName: '',
        key: '',
      },
      stringifyExchange: '',
      ruleValidate: {
        fieldName: [
          {required: true, message: '字段名不能为空', trigger: 'blur'}
        ],
        // exchange: [
        //   {required: true, message: '请设置字段字典', trigger: 'blur'}
        // ],
        showName: [
          {required: true, message: '显示列名不能为空', trigger: 'blur'}
        ],
        fieldType: [
          {required: true, message: '请选择类型', trigger: 'blur'}
        ],
      },
    }
  },
  computed: {
  },
  created() {
    // this.setKey()
    this.setDefualtData()
  },
  mounted() {},
  destroyed() {},
  methods: {
    setExchange(){
      this.show = true
      if(this.formData.exchange.length==0){
        this.formData.exchange.push({
          name: '',
          value: '',
          key: (new Date()).getTime() // 加入唯一标识避免渲染错误
        })
      }
      const _this = this
      this.$nextTick(() => {
        _this.formData.exchange.forEach((item, index) => {
          _this.$refs.dictionary[index].getDefualtData()
        });
      })
    },
    addExchange(){
      const exchange = this.formData.exchange
      this.formData.exchange.push({
        name: '',
        value: '',
        key: (new Date()).getTime() // 加入唯一标识避免渲染错误
      })
      const _this = this
      this.$nextTick(() => {
        _this.$refs.dictionary[this.formData.exchange.length - 1].getDefualtData()
      })
    },
    handleClose(done){
      // 过滤掉未保存的数据
      this.formData.exchange = this.formData.exchange.filter(item => {
        return (item.name && item.value)
      })
      this.show = false
    },
    validateDictionaryForm(){
      let resultArr = []
      const _this = this;
      function checkForm(index) {
        let result = new Promise(function(resolve, reject) {
          _this.$refs.dictionary[index].$refs.dictionaryForm.validate((valid) => {
            if (valid) {
              resolve(_this.$refs.dictionary[index].getData());
            } else {
              reject()
            }
          })
        })
        resultArr.push(result)
      }
      this.formData.exchange.forEach((item, index) => {
        checkForm(index)
      });
      Promise.all(resultArr).then((res) => {
        this.formData.exchange = res
        this.stringifyExchange = JSON.stringify(res)
        this.show = false
      })
    },
    removeItem(index){
      this.formData.exchange.splice(index, 1)
    },
    getValue(){
      return this.formData
    },
    removeShowItem(){
      this.$emit('removeItemForm', {dataName: 'queryResultDefList', index: this.itemIndex})
    },
    setDefualtData(){
      this.formData = {
        fieldName: this.itemData.fieldName,
        fieldType: this.itemData.fieldType,
        showName: this.itemData.showName,
        key: this.itemData.key,
        exchange: [],
      }
      if(this.itemData.exchange && this.itemData.exchange.length){
        this.formData.exchange = JSON.parse(this.itemData.exchange)
        this.stringifyExchange = this.itemData.exchange
      }
    },
  },
  watch: {
    formData: {
      handler(val) {
        let data = JSON.parse(JSON.stringify(val))
        data.exchange = this.stringifyExchange
        this.$emit('showItemFormChange', {data, index: this.itemIndex})
      },
      deep: true,
    }
  },
  filters: {}
};
</script>

<style scoped lang="less">
</style>
